import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  TextareaAutosize,
  Dialog,
  DialogActions,
  DialogContent,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PrimaryDialogTitle } from "../../../Components/Common/Dialog/DialogComponents";
import moment from "moment";
import "../../../Sass/Common.scss";
import useViewport from "../../../Hooks/useViewport";
import { useSelector } from "react-redux";
import TodaysOrder from "../../../Components/RepeatOrder/TodaysOrder";
import { ReactComponent as ModalCloseIcon } from "../../../Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import { ReactComponent as NoteTextIcon } from "../../../Assets/Icons/PharmsmartIcon/NoteTextcon.svg";
import PrimaryIcon from "../../../Components/Common/PrimaryIcon";
import { useNotification } from "Hooks/NotificationManager";
const useStyle = makeStyles((theme) => ({
  rsPatientMedicationBtn: {
    "&>button": {
      fontSize: "14px !important",
      fontWeight: "400 !important",
      borderRadius: "5px !important",
    },
  },
  rsViewOrderMain: {
    // alignItems: "center",
    // justifyContent: "center",
    // [theme.breakpoints.down("1000")]: {
    //   width: "calc(100% + 200px) !important",
    //   marginLeft: "-90px !important",
    // },
    // "&>div": {
    //   marginTop: "10px",
    //   textAlign: "center",
    // },
  },
  rsViewOrderGridOne: {
    "&>div": {
      "&>div": {
        marginTop: "10px",
      },
      "&>button": {
        width: "5px !important",
        height: "30px !important",
        marginLeft: "-5px",
        fontSize: "12px !important",
      },
      "&>h4": {
        fontSize: "16px",
        fontWeight: "Bold",
        paddingTop: "20px",
        paddingRight: "7px",
      },
    },
  },
  rsViewOrderMultiline: {
    "&>button": {
      width: "5px !important",
      height: "300px !important",
      marginLeft: "-1px",
      fontSize: "12px !important",
    },
  },
  rsTextArea: {
    width: "100%",
    height: "300px !important",
    color: theme.palette.secondary.main,
    fontSize: "14px",
    fontFamily: "Poppins",
    background: "#f3f3f3",
  },
  rsLoading: {
    display: "flex",
    justifyContent: "center",
  },
  rsViewOrderGridOneExtra: {
    margin: "0px",
    paddingTop: "0px !important",
    "&>div": {
      "&>div": {
        "&>div": {
          marginTop: "10px",
        },
      },
      "&>button": {
        width: "5px !important",
        height: "30px !important",
        marginLeft: "-5px",
        fontSize: "12px !important",
      },
      "&>h4": {
        marginRight: "10px",
        fontSize: "16px",
        marginTop: "10px",
      },
    },
  },
  rsViewOrderGridOneTo: {
    "&>div": {
      "&>div": {
        // height: "30px !important",
        "&>div": {
          background: "#f3f3f3",
        },
      },
      "&>button": {
        width: "5px !important",
        height: "30px !important",
        marginLeft: "-5px",
        fontSize: "12px !important",
      },
      "&>h4": {
        marginLeft: "35px",
        marginRight: "10px",
        fontSize: "16px",
        marginTop: "10px",
        fontWeight: "bold",
      },
    },
  },
  rsNote: {
    color: "red",
    borderColor: "red",
    border: "2px",
    fontSize: "14px",
    marginTop: "-15px",
    borderStyle: "double",
    marginLeft: "10px",
    padding: "10px",
    borderRadius: "4px",
  },
  rsViewOrderGridOneMessage: {
    marginTop: "10px !important",
  },
}));

const CopyButton = ({ inputId, copiedInputId, setCopiedInputId }) => {
  function handleCopy(inputId) {
    let textarea = document.getElementById(inputId);
    textarea.select();
    document.execCommand("copy");
    setCopiedInputId(inputId);
  }

  return (
    <Button variant="contained" onClick={() => handleCopy(inputId)}>
      {copiedInputId === inputId ? "Copied" : "Copy"}
    </Button>
  );
};

const ViewOrderDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    body,
    actionType,
    displayType,
    viewOrderData,
    setViewOrderData,
    collect,
    collectionViewRxAction,
    collectedUncollectedListShow,
    collectAndUncollectedViewRxDetails,
    sendMail,
    orderId,
    patientId,
    createorderPadAction,
    createOrderPadData,
    fromChaseup,
    actionTypeChaseUP,
    collectionViewRxDetails,
    chaseUpActiveStatus,
    UpdateChaseUp,
    setChaseupClose,
    fromAddRx,
    createTodayOrderPadAction,
    addRxMedi,
    orderPadDataData,
    showNoOfMedication,
    noofMediOrderPad,
    setInAddRx,
    nextOrderDate,
    setSubscritionDialog,
    dateDate,
  } = props;
  const notification = useNotification();
  const [copiedInputId, setCopiedInputId] = useState("");
  const loginUserDetail = useSelector((state) => state.user);
  const [message, setMessage] = useState("");
  const [subjectValue, setSubjectValue] = useState(
    "Prescription Order Request",
  );
  const [extraValue, setExtraValue] = useState("");
  const [todaysOrder, setTodaysOrder] = useState(false);
  const handleSubmit = (formValues) => {
    if (loginUserDetail?.loginUserDetail?.data?.data?.is_applied_payment) {
      if (loginUserDetail?.loginUserDetail?.data?.data?.is_expired) {
        setSubscritionDialog(true);
      } else {
        if (fromChaseup) {
          let tempMail = {};
          let payload = {
            id: collectionViewRxDetails?.data?.id,
            type: actionTypeChaseUP,
            email: collectionViewRxDetails?.data?.surgery?.email,
            subject: subjectValue,
            message: `${"\r\n \r\n"} ${extraValue} ${message}`,
          };
          UpdateChaseUp(
            collectionViewRxDetails?.data?.id,
            payload,
            chaseUpActiveStatus,
          );
          setChaseupClose(false);
          setOpen(false);
        } else if (fromAddRx) {
          let payloadTempMedi = {};
          payloadTempMedi.medication = [];
          payloadTempMedi.new_medication = [];
          addRxMedi.map((item) => {
            const { id, name, quantity } = item;
            if (item?.action) {
              if (!item.hasOwnProperty("isNew")) {
                payloadTempMedi.medication.push({
                  id,
                });
              } else {
                // payload.new_medication = [];
                payloadTempMedi.new_medication.push({
                  drug_name: name,
                  quantity,
                  action: true,
                });
              }
            }
          });
          if (payloadTempMedi.medication.length === 0 && payloadTempMedi.new_medication.length === 0) {
            notification.error("Please select medication");
            return;
          }
          if (showNoOfMedication) {
            payloadTempMedi.number_of_medication = noofMediOrderPad;
          }
          const _payload = {
            ...payloadTempMedi,
            patient_id: orderPadDataData?.id,
            ordering_method: "email",
            subject: subjectValue,
            email: orderPadDataData?.surgery_name?.email,
            message: `${"\r\n \r\n"} ${extraValue} ${message}`,
            surgery_id: viewOrderData?.surgery_id,
          };
          setInAddRx(true);
          createTodayOrderPadAction(_payload);
        } else {
          if (viewOrderData?.is_today_order) {
            setTodaysOrder(true);
          } else {
            let oldList = viewOrderData?.medication;
            oldList = oldList?.map((item) => {
              if (item?.action === true) {
                return {
                  id: item?.id,
                };
              } else {
                return null;
              }
            });

            const payloadMail = {
              patient_id: patientId,
              order_id: orderId,
              ordering_method: "email",
              // medication: final,
              subject: subjectValue,
              email: viewOrderData?.surgeryEmail,
              message: ` ${"\r\n \r\n"} ${extraValue} ${message}`,
              surgery_id: viewOrderData?.surgery_id,
            };
            const payLoadMail = {
              patient_id: patientId,
              order_id: orderId,
              ordering_method: "email",
              number_of_medication: viewOrderData?.number_of_medication,
              subject: subjectValue,
              email: viewOrderData?.surgeryEmail,
              message: ` ${"\r\n \r\n"} ${extraValue} ${message}`,
              surgery_id: viewOrderData?.surgery_id,
            };

            let final = oldList.filter((value) => value != null);
            // const newMedications = viewOrderData.filter((item) => item.isNew);
            // if (newMedications?.length > 0) {
            //   payloadMail.new_medication = [];
            // } else {
            payloadMail.medication = [];
            // }
            viewOrderData?.medication.map((item) => {
              const { id, name, quantity, changeable_prn, action } = item;
              if (!item.hasOwnProperty("isNew")) {
                // payloadMail.medication = [];
                if (action === true) {
                  payloadMail.medication.push({ id });
                }
                // payLoad.medication.push(item);
              } else {
                // payloadMail.new_medication = [];
                payloadMail.new_medication.push({
                  drug_name: name,
                  quantity,
                  action: true,
                  changeable_prn: changeable_prn,
                });
              }
            });

            console.log(
              "viewOrderData?.pharmacy_id 1 == > ",
              viewOrderData?.pharmacy_id,
            );

            if (viewOrderData?.pharmacy_id) {
              payloadMail.pharmacy_id = viewOrderData?.pharmacy_id;
              payLoadMail.pharmacy_id = viewOrderData?.pharmacy_id;
            }
            if (viewOrderData?.old_order_date) {
              payloadMail.old_order_date = nextOrderDate;
            }
            if (nextOrderDate) {
              payloadMail.next_order_date = nextOrderDate;
              payLoadMail.next_order_date = nextOrderDate;
            }
            if (viewOrderData?.medication_type === "number") {
              createorderPadAction(payLoadMail);
              handleClose();
            } else {
              createorderPadAction(payloadMail);
              handleClose();
            }
          }
        }
      }
    } else {
      if (fromChaseup) {
        let tempMail = {};
        let payload = {
          id: collectionViewRxDetails?.data?.id,
          type: actionTypeChaseUP,
          email: collectionViewRxDetails?.data?.surgery?.email,
          subject: subjectValue,
          message: `${"\r\n \r\n"} ${extraValue} ${message}`,
        };
        UpdateChaseUp(
          collectionViewRxDetails?.data?.id,
          payload,
          chaseUpActiveStatus,
        );
        setChaseupClose(false);
        setOpen(false);
      } else if (fromAddRx) {
        let payloadTempMedi = {};
        payloadTempMedi.medication = [];
        payloadTempMedi.new_medication = [];
        addRxMedi.map((item) => {
          const { id, name, quantity } = item;
          if (item?.action) {
            if (!item.hasOwnProperty("isNew")) {
              payloadTempMedi.medication.push({
                id,
              });
            } else {
              // payload.new_medication = [];
              payloadTempMedi.new_medication.push({
                drug_name: name,
                quantity,
                action: true,
              });
            }
          }
        });
        if (showNoOfMedication) {
          payloadTempMedi.number_of_medication = noofMediOrderPad;
        }
        const _payload = {
          ...payloadTempMedi,
          patient_id: orderPadDataData?.id,
          ordering_method: "email",
          subject: subjectValue,
          email: orderPadDataData?.surgery_name?.email,
          message: `${"\r\n \r\n"} ${extraValue} ${message}`,
        };
        setInAddRx(true);
        createTodayOrderPadAction(_payload);
      } else {
        if (viewOrderData?.is_today_order) {
          setTodaysOrder(true);
        } else {
          let oldList = viewOrderData?.medication;
          oldList = oldList?.map((item) => {
            if (item?.action === true) {
              return {
                id: item?.id,
              };
            } else {
              return null;
            }
          });

          const payloadMail = {
            patient_id: patientId,
            order_id: orderId,
            ordering_method: "email",
            // medication: final,
            subject: subjectValue,
            email: viewOrderData?.surgeryEmail,
            message: ` ${"\r\n \r\n"} ${extraValue} ${message}`,
            surgery_id: viewOrderData?.surgery_id,
          };
          const payLoadMail = {
            patient_id: patientId,
            order_id: orderId,
            ordering_method: "email",
            number_of_medication: viewOrderData?.number_of_medication,
            subject: subjectValue,
            email: viewOrderData?.surgeryEmail,
            message: ` ${"\r\n \r\n"} ${extraValue} ${message}`,
            surgery_id: viewOrderData?.surgery_id,
          };
          let final = oldList.filter((value) => value != null);
          const newMedications = viewOrderData.filter((item) => item.isNew);
          if (newMedications?.length > 0) {
            payloadMail.new_medication = [];
          } else {
            payloadMail.medication = [];
          }
          viewOrderData?.medication.map((item) => {
            const { id, name, quantity, changeable_prn } = item;
            if (!item.hasOwnProperty("isNew")) {
              // payloadMail.medication = [];
              payloadMail.medication?.push({ id });
              // payLoad.medication.push(item);
            } else {
              // payloadMail.new_medication = [];
              // payload.new_medication = [];
              payloadMail.new_medication?.push({
                drug_name: name,
                quantity,
                action: true,
                changeable_prn: changeable_prn,
              });
            }
          });

          console.log(
            "viewOrderData?.pharmacy_id --- > ",
            viewOrderData?.pharmacy_id,
          );

          if (viewOrderData?.pharmacy_id) {
            payloadMail.pharmacy_id = viewOrderData?.pharmacy_id;
            payLoadMail.pharmacy_id = viewOrderData?.pharmacy_id;
          }
          if (viewOrderData?.old_order_date) {
            payloadMail.old_order_date = nextOrderDate;
          }
          if (nextOrderDate) {
            payloadMail.next_order_date = nextOrderDate;
            payLoadMail.next_order_date = nextOrderDate;
          }
          if (viewOrderData?.medication_type === "number") {
            createorderPadAction(payLoadMail);
            handleClose();
          } else {
            createorderPadAction(payloadMail);
            handleClose();
          }
        }
      }
    }
  };
  const handleSubmitOrder = () => {
    console.log(" Checking function hit ");
    setTodaysOrder(false);
    let oldList = viewOrderData?.medication;
    oldList = oldList?.map((item) => {
      if (item?.action === true) {
        return {
          id: item?.id,
        };
      } else {
        return null;
      }
    });
    let final = oldList.filter((value) => value != null);
    const payloadMail = {
      patient_id: patientId,
      order_id: orderId,
      ordering_method: "email",
      medication: final,
      subject: subjectValue,
      email: viewOrderData?.surgeryEmail,
      message: ` ${"\r\n \r\n"} ${extraValue} ${message}`,
    };
    const payLoadMail = {
      patient_id: patientId,
      order_id: orderId,
      ordering_method: "email",
      number_of_medication: viewOrderData?.number_of_medication,
      subject: subjectValue,
      email: viewOrderData?.surgeryEmail,
      message: ` ${"\r\n \r\n"} ${extraValue} ${message}`,
    };

    console.log(
      "viewOrderData?.pharmacy_id HANDLE SUBMIT ORDEER == > ",
      viewOrderData?.pharmacy_id,
    );

    if (nextOrderDate) {
      payloadMail.next_order_date = nextOrderDate;
      payLoadMail.next_order_date = nextOrderDate;
    }
    if (viewOrderData?.old_order_date) {
      payloadMail.old_order_date = nextOrderDate;
    }
    if (viewOrderData?.pharmacy_id) {
      payloadMail.pharmacy_id = viewOrderData?.pharmacy_id;
      payLoadMail.pharmacy_id = viewOrderData?.pharmacy_id;
    }
    if (viewOrderData?.medication_type === "number") {
      createorderPadAction(payLoadMail);
      handleClose();
    } else {
      createorderPadAction(payloadMail);
      handleClose();
    }
  };
  useEffect(() => {
    if (viewOrderData?.surgeryName) {
      let temp = `
      ${"\r\n"} Dear ${viewOrderData?.surgeryName
        },${"\r\n \r\n"} Please can I order a repeat prescription for the following ${"\r\n \r\n"} Patient name: ${viewOrderData?.name
        } ${viewOrderData?.last_name ? viewOrderData?.last_name : ""
        } ${"\r\n \r\n"} ${viewOrderData?.nhs_number ? `NHS number: ${viewOrderData?.nhs_number}` : "N/A"}  ${"\r\n \r\n"} DOB : ${viewOrderData?.dob
          ? moment(new Date(viewOrderData?.dob)).format("DD MMM YYYY")
          : "N/A"
        }  ${"\r\n \r\n"} Medication:${viewOrderData?.medication_type !== "number" ? "\r\n" : ""
        }
      ${viewOrderData?.medication_type === "number"
          ? ` ${viewOrderData?.number_of_medication}  ${actionType === "Chaseup" || actionType === "viewRx"
            ? viewOrderData?.medicationCollected === 0 ||
              viewOrderData?.medicationRemoved === 0 ||
              viewOrderData?.medicationUncollected === 0
              ? " "
              : ` (${viewOrderData?.medicationCollected} Collected)   (${viewOrderData?.medicationRemoved} Removed)  (${viewOrderData?.medicationUncollected} Uncollected)`
            : ""
          }`
          : viewOrderData?.medication
            ?.map((item) =>
              item.action === true ||
                actionType === "Chaseup" ||
                actionType === "viewRx"
                ? `${"\r\n"} ${item?.drug_name ? item?.drug_name : item?.name
                }  ${item?.quantity ? `/ Quantity:${item?.quantity}` : ""
                } ,`
                : ``,
            )
            .join("")
        }
           ${"\r\n \r\n"} Best regards, ${"\r\n \r\n"} ${loginUserDetail?.loginUserDetail?.data?.data?.role !== "pharmacy"
          ? loginUserDetail?.loginUserDetail?.data?.data?.name ||
          body?.data?.created_by?.name ||
          viewOrderData?.created_by?.name ||
          orderPadDataData?.created_by?.name
          : ""
        }${"\r\n"} ${body?.data?.pharmacy?.name ||
        viewOrderData?.pharmacy_detail?.name ||
        orderPadDataData?.pharmacy_name?.name
        } ${"\r\n \r\n"}`;
      setMessage(temp);
    }
  }, [viewOrderData]);

  const handleClose = () => {
    setOpen(false);
    setCopiedInputId("");
    setExtraValue("");
    setMessage("");
    setSubjectValue("Prescription Order Request");
  };
  const { width } = useViewport();
  useEffect(() => {
    if (open && collect) {
      let payload = {
        type: collectedUncollectedListShow,
      };
      collectionViewRxAction(collectAndUncollectedViewRxDetails, payload);
    }
  }, [open]);
  useEffect(() => {
    if (open && body?.data) {
      let tempCollected = 0;
      let tempRemoved = 0;
      let medications = [];
      let numberOfMedication = 0;
      let tempNumberOfMedication =
        body?.data?.number_of_medication || numberOfMedication;
      let tempData = {
        medication:
          medications.length > 0
            ? medications
            : body?.data?.patient_medications,
        surgeryName: body?.data?.surgery?.name,
        surgeryEmail: body?.data?.surgery?.email,
        dob: body?.data?.dob ? body?.data?.dob : "",
        name: body?.data?.name,
        nhs_number: body?.data?.nhs_number,
        last_name: body?.data?.last_name,
        medication_type: body?.data?.medication_type,
        number_of_medication: tempNumberOfMedication,
        medicationCollected: tempCollected,
        medicationRemoved: tempRemoved,
        medicationUncollected:
          tempNumberOfMedication - tempCollected - tempRemoved,
        phone: body?.data?.surgery?.phone,
        fax: body?.data?.surgery?.fax,
      };
      setViewOrderData(tempData);
    }
  }, [body]);

  const handleChangeSubject = (e) => {
    setSubjectValue(e.target.value);
  };
  const handleChangeExtra = (e) => {
    setExtraValue(e.target.value);
  };

  return (
    <Box className={classes.ModalHeading}>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={() => handleClose()}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        sx={
          width < 1000
            ? {
              "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                  width: "100%",

                  maxWidth: "600px", // Set your width here
                },
              },
            }
            : width < 1100
              ? {
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",

                    maxWidth: "800px", // Set your width here
                  },
                },
              }
              : width < 1200
                ? {
                  "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                      width: "100%",

                      // maxWidth: "1000px", // Set your width here
                    },
                  },
                }
                : {}
        }
        className="RSxs_modal"
      // className="rsDialogMain"
      >
        {/* <PrimaryDialogTitle /> */}
        {body?.loading || !viewOrderData?.name ? (
          <Box className={classes.rsLoading}>
            <CircularProgress
              className={classes.progress}
              color="primary"
              disableShrink
            />
          </Box>
        ) : (
          <Box className="rsNoteGrid">
            <Box className="ModalHeading">
              <Box
                className="ModalIconWidth"
                textAlign={"center"}
                justifyContent={"center"}
              >
                <PrimaryIcon
                  icon={NoteTextIcon}
                  color="white"
                  className="FilterGreen"
                  handleClose={handleClose}
                />
                <Box className="ModalTitleView">
                  <PrimaryDialogTitle title={"Prescription Order Request"} />
                </Box>
              </Box>
              <IconButton
                onClick={() => handleClose()}
                className="ModalCloseIcon"
              >
                <PrimaryIcon icon={ModalCloseIcon} />
              </IconButton>
            </Box>
            <DialogContent className="DialogContentBoxView">
              <Grid className={classes.rsViewOrderMain}>
                {viewOrderData?.surgeryEmail && (
                  <Grid
                    item
                    xs={8}
                    sm={8}
                    md={8}
                    lg={8}
                    className={classes.rsViewOrderGridOneTo}
                  >
                    <Box display={"flex"}>
                      <Typography variant="h4" color="black">
                        To
                      </Typography>
                      <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="name"
                        id="email"
                        value={viewOrderData?.surgeryEmail}
                      />
                      {/* <CopyButton
                          inputId={"email"}
                          copiedInputId={copiedInputId}
                          setCopiedInputId={setCopiedInputId}
                        /> */}
                    </Box>
                    {/* <Box display={"flex"}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="name"
                          id="email"
                          value={viewOrderData?.surgeryEmail}
                        />
                        <CopyButton
                          inputId={"email"}
                          copiedInputId={copiedInputId}
                          setCopiedInputId={setCopiedInputId}
                        />
                      </Box> */}
                  </Grid>
                )}
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  className={classes.rsViewOrderGridOne}
                >
                  <Box display={"flex"}>
                    <Typography variant="h4" color="black">
                      Subject
                    </Typography>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      name="mail"
                      id="prescriptionOrderRequest"
                      value={subjectValue}
                      onChange={handleChangeSubject}
                    />
                    {/* <CopyButton
                        inputId={"prescriptionOrderRequest"}
                        copiedInputId={copiedInputId}
                        setCopiedInputId={setCopiedInputId}
                      /> */}
                    <Box className={classes.rsNote}>
                      Do not add any patient identifiable details to this mail
                    </Box>
                  </Box>
                  {/* <Box display={"flex"}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="mail"
                        id="prescriptionOrderRequest"
                        value={"Prescription Order Request"}
                      />
                      <CopyButton
                        inputId={"prescriptionOrderRequest"}
                        copiedInputId={copiedInputId}
                        setCopiedInputId={setCopiedInputId}
                      />
                    </Box> */}
                </Grid>
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  className={classes.rsViewOrderGridOneExtra}
                >
                  <Box display={"flex"}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      name="mail"
                      id="extraText"
                      value={extraValue}
                      onChange={handleChangeExtra}
                      placeholder="Type here to add text to top of the email..."
                    />
                    {/* <CopyButton
                        inputId={"extraText"}
                        copiedInputId={copiedInputId}
                        setCopiedInputId={setCopiedInputId}
                      /> */}
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  className={classes.rsViewOrderGridOneMessage}
                >
                  <Box
                    display={"flex"}
                    className={classes.rsViewOrderMultiline}
                  >
                    <TextareaAutosize
                      maxRows={1}
                      fullWidth
                      className={classes.rsTextArea}
                      aria-label="maximum height"
                      placeholder="Maximum 4 rows"
                      id="useInfo"
                      value={`${"\r\n \r\n"} Dear ${viewOrderData?.surgeryName
                        },${"\r\n \r\n"} Please can I order a repeat prescription for the following ${"\r\n \r\n"} Patient name: ${viewOrderData?.name
                        } ${viewOrderData?.last_name ? viewOrderData?.last_name : ""
                        }  ${"\r\n \r\n"} NHS number: ${viewOrderData?.nhs_number ? `${viewOrderData?.nhs_number}` : 'N/A'} ${"\r\n \r\n"} DOB : ${viewOrderData?.dob
                          ? moment(new Date(viewOrderData?.dob)).format(
                            "DD MMM YYYY",
                          )
                          : "N/A"
                        }  ${"\r\n \r\n"} Medication:${viewOrderData?.medication_type !== "number"
                          ? "\r\n"
                          : ""
                        }${viewOrderData?.medication_type === "number"
                          ? ` ${viewOrderData?.number_of_medication}  ${actionType === "Chaseup" ||
                            actionType === "viewRx"
                            ? viewOrderData?.medicationCollected === 0 ||
                              viewOrderData?.medicationRemoved === 0 ||
                              viewOrderData?.medicationUncollected === 0
                              ? " "
                              : ` (${viewOrderData?.medicationCollected} Collected)   (${viewOrderData?.medicationRemoved} Removed)  (${viewOrderData?.medicationUncollected} Uncollected)`
                            : ""
                          }`
                          : viewOrderData?.medication
                            ?.map((item) =>
                              item.action === true ||
                                actionType === "Chaseup" ||
                                actionType === "viewRx"
                                ? `${"\r\n"} ${item?.drug_name
                                  ? item?.drug_name
                                  : item?.name
                                }  ${item?.quantity
                                  ? `/ Quantity:${item?.quantity}`
                                  : ""
                                },`
                                : ``,
                            )
                            .join("")
                        }
                      
                            ${"\r\n \r\n"} Best regards, ${"\r\n \r\n"} ${loginUserDetail?.loginUserDetail?.data?.data
                          ?.role !== "pharmacy"
                          ? loginUserDetail?.loginUserDetail?.data?.data
                            ?.name ||
                          body?.data?.created_by?.name ||
                          viewOrderData?.created_by?.name ||
                          orderPadDataData?.created_by?.name
                          : ""
                        }${"\r\n"} ${body?.data?.pharmacy?.name ||
                        viewOrderData?.pharmacy_detail?.name ||
                        orderPadDataData?.pharmacy_name?.name
                        } ${"\r\n \r\n"}`}
                    />
                    {/* <CopyButton
                        inputId={"useInfo"}
                        copiedInputId={copiedInputId}
                        setCopiedInputId={setCopiedInputId}
                      /> */}
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
          </Box>
        )}

        <DialogActions style={{ padding: "8px" }}>
          {sendMail && (
            <Button
              className="BtnGreen"
              variant="contained"
              disabled={createOrderPadData?.loading}
              onClick={() => handleSubmit()}
            >
              {fromChaseup
                ? "Resend email"
                : fromAddRx
                  ? "Proceed & Send"
                  : "Send"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <TodaysOrder
        open={todaysOrder}
        setOpen={setTodaysOrder}
        handleSubmit={handleSubmitOrder}
      />
    </Box>
  );
};

export default ViewOrderDialog;
